import script from "./F2LSection.vue?vue&type=script&setup=true&lang=js"
export * from "./F2LSection.vue?vue&type=script&setup=true&lang=js"

import "./F2LSection.vue?vue&type=style&index=0&id=7e7920d6&lang=css"

const __exports__ = script;

export default __exports__